import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import YearlyStatistics from '../components/YearlyStatistics';

const Analytics: React.FC = () => {
  const { user } = useAuth();

  if (!user?.orgID) {
    return (
      <div style={{ textAlign: 'center', padding: 40, color: '#666' }}>
        Keine Organisation gefunden.
      </div>
    );
  }

  return <YearlyStatistics orgID={user.orgID} />;
};

export default Analytics;

